export const CONVERSATION_END_TOKEN = "[CONVERSATION_END]";

export function stripEndToken(text: string): { display: string; ended: boolean } {
  const idx = text.indexOf(CONVERSATION_END_TOKEN);
  if (idx === -1) {
    return { display: text, ended: false };
  }
  return {
    display: text.slice(0, idx).trimEnd(),
    ended: true,
  };
}
